export var ACTIONS;
(function (ACTIONS) {
    ACTIONS["SET_PLATFORM_JOURNEY"] = "SET_PLATFORM_JOURNEY";
})(ACTIONS || (ACTIONS = {}));
//# sourceMappingURL=types.js.map